<template>
    <div
        class="tw-my-8"
    >
        <Heading title="Wie lange möchtest Du ungefähr unterwegs sein?" :size="3" />
        <info-snippet hasBackground class="tw-mb-10">
            Je länger die Reisedauer, desto geringer Dein ökologischer Fußabdruck und umso höher Dein authentisches Erlebnis im Reiseziel.
        </info-snippet>
        <vue-slider
            class="tw-mb-4 tw-mt-8 tw-mx-4"
            v-model="sliderValue"
            :data="values"
            :marks="marks"
            :lazy="true"
            :dot-size="25"
            :tooltip="'always'"
            :process-style="{ backgroundColor: '#979797' }"
            :dot-style="{ backgroundColor: '#E15D61', boxShadow: '0 0 0 0' }"
            :tooltip-style="{ backgroundColor: '#E15D61', borderColor: '#E15D61'}"
            :tooltip-formatter="value => value + ' Tage'"
        />
    </div>
</template>

<script>
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import InfoSnippet from "./InfoSnippet.vue";
export default {
    name: "DurationSelector",
    components: {
        InfoSnippet,
        VueSlider
    },
    data: () => ({
        values: ['5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28+'],
        marks: {
            '5': {
                label: '5 Tage',
                labelStyle: {
                    color: '#979797',
                },
            },
            '28+': {
                label: '28+ Tage',
                labelStyle: {
                    color: '#979797',
                },
            }
        },
        sliderValue: '14',
    }),
    mounted() {
        // if we have stored travelData, it overrules the default value and the route value
        if (localStorage.getItem('travelData') && this.$store.getters['tour/travelData']?.duration) {
            this.sliderValue = this.$store.getters['tour/travelData'].duration.toString();
        // if we don't have stored travelData, but we have a route, we can use the duration from the route
        } else if (this.$store.getters['tour/route']?.durationInDays) {
            this.sliderValue = this.$store.getters['tour/route'].durationInDays.toString();
        }
        // otherwise, just use the default 14 days
        this.$store.commit('tour/setDuration', parseInt(this.sliderValue));
    },
    watch: {
        sliderValue: function (val) {
            this.$store.commit('tour/setDuration', parseInt(val));
        }
    }
}
</script>
